import { Button, Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { COLORS } from '../../../utils/Application_Constants';

const ConfirmationModal = ({
    open,
    title,
    subtitle,
    onConfirm,
    onClose,
    isLoading,
    actionButtonLabel,
    actionButtonColor = 'primary',
}) => (
    <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        slotProps={{ paper: { sx: { borderRadius: '8px', padding: '30px' } } }}
    >
        <DialogTitle>
            <Typography variant="heading3" sx={{ color: COLORS.BLACK }}>
                {title}
            </Typography>
        </DialogTitle>
        <DialogContent>
            <Typography variant="body2">{subtitle}</Typography>

            <Stack direction="row" sx={{ mt: 4 }}>
                <Button
                    variant="lt-admin-outlined"
                    color="primary"
                    sx={{ mr: 2 }}
                    onClick={onClose}
                    disabled={isLoading}
                >
                    Cancel
                </Button>
                <Button
                    variant="lt-admin-contained"
                    color={actionButtonColor}
                    type="button"
                    onClick={onConfirm}
                    loading={isLoading}
                    sx={{ ml: 'auto' }}
                >
                    {actionButtonLabel}
                </Button>
            </Stack>
        </DialogContent>
    </Dialog>
);

export default ConfirmationModal;
